import { Route } from '@angular/router';
import { KIDS_TERMINE_PATH, KIDS_TERMINE_TITLE } from '../../mgs-path-defs';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { kidsDatenResolver } from '../kids-daten.resolver';
import { mgsAuthenticatedGuard, mgsKidsGuard } from '../../mgs-guards';

export const kidsTermineRoute: Route = {
  path: KIDS_TERMINE_PATH,
  title: KIDS_TERMINE_TITLE,
  loadComponent: () => import('./kids-termine.component'),
  canActivate: [mgsAuthenticatedGuard, mgsKidsGuard],
  resolve: { kidsDaten: kidsDatenResolver, icons: mgsIconsResolver }
};
